var _desc;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgParchment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    overflow: "visible",
    preserveAspectRatio: "none",
    viewBox: "0 0 470 584",
    height: 582,
    width: 468,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1, 1)"
  }, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    fill: "none",
    strokeWidth: 1,
    stroke: "none",
    id: "Parchment_1586890906461"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#000000",
    transform: "translate(2.000000, 2.000000)",
    id: "parchment_1586890906461"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 2,
    id: "STROKE_20701b46-787a-441e-aa2f-22b452f2d6a2_1__1586890906461",
    d: "M5.39120691,526.1 C3.09120691,484.8 3.19120691,440.7 2.49120691,399.1 C2.49120691,375.8 -8.40879309,351.6 15.3912069,338.1 C9.69120691,333.8 2.99120691,333.8 2.19120691,327.1 C1.29120691,310.1 7.09120691,291.4 7.79120691,274 C9.29120691,230.7 11.4912069,186.3 13.6912069,143.4 C16.4912069,138.6 21.5912069,134.9 26.4912069,131.8 C9.79120691,122.4 8.99120691,127.1 6.09120691,116.1 C3.99120691,82.4 -3.00879309,41.9 12.5912069,10.6 C153.091207,-4 300.191207,10.3 440.991207,0 C441.591207,3.2 443.591207,5.3 443.391207,6.4 C445.691207,41 449.891207,75.9 446.791207,110.7 C444.691207,127 449.991207,148.3 432.691207,156.9 C427.891207,160.3 435.591207,164.3 436.291207,168.7 C438.891207,200.1 437.091207,239.9 438.491207,272.1 C441.891207,305.7 447.491207,346 447.991207,379.9 C455.091207,422.6 446.891207,473.4 458.091207,515.3 C460.791207,524.3 462.891207,557.5 463.991207,568.9 C444.891207,565.4 411.091207,570.2 403.691207,568.7 C381.191207,567 356.191207,571.3 335.591207,561.6 C333.491207,564.1 330.791207,569.6 329.191207,572.3 C249.591207,582.5 173.391207,577 94.7912069,567.1 C89.8912069,559.9 90.4912069,560 87.9912069,554.8 C81.2912069,559.3 78.7912069,564 71.0912069,568.1 C56.3912069,570 40.7912069,567.6 25.9912069,566.2 C-10.7087931,565.3 5.09120691,557.7 5.39120691,526.1 Z",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(240, 238, 233)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "#000000",
    strokeWidth: 0.2,
    id: "STROKE_8b6aa0db-a790-41e2-8bb8-d05243d4a29a_1586890906461",
    d: "M12.3912069,374.8 C16.2912069,374.7 16.2912069,380.9 12.3912069,380.8 C8.49120691,380.9 8.49120691,374.8 12.3912069,374.8 Z",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(240, 238, 233)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 3,
    id: "STROKE_d60def88-6cd3-40f2-9a4d-106cbe74f102_1586890906461",
    d: "M11.4912069,411 C11.9912069,410.5 12.2912069,410.3 12.4912069,410.3 C13.4912069,409.7 17.6912069,408.4 19.1912069,407.8",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(240, 238, 233)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 3,
    id: "STROKE_8833ac8f-bfb3-4b65-986e-e1b4482a90b8_1586890906461",
    d: "M13.3912069,444.2 C16.1912069,441.7 18.5912069,442 21.9912069,440.4",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(240, 238, 233)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 3,
    id: "STROKE_338db44b-36d8-4574-9706-78efe77ccc9e_1586890906461",
    d: "M8.69120691,456.7 C12.0912069,456.2 13.9912069,455.5 17.8912069,454.3",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(240, 238, 233)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 3,
    id: "STROKE_a5860454-e64c-41d9-8756-da9599467109_1586890906461",
    d: "M9.29120691,466.1 C10.0912069,465.8 10.4912069,465.5 10.5912069,465.4 C13.8912069,463.4 13.2912069,464.1 17.7912069,462.6",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(240, 238, 233)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 3,
    id: "STROKE_c912ef51-8462-46e3-9bcf-34b4bf463542_1586890906461",
    d: "M27.1912069,20.2 C27.1912069,20.3 27.2912069,20.5 27.3912069,20.7 C27.4912069,25.2 27.5912069,28.1 27.5912069,29.5",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(240, 238, 233)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 3,
    id: "STROKE_1b5ed413-2f6f-4c3c-899c-fea5764edcb2_1586890906461",
    d: "M41.2912069,18.3 C40.6912069,20.7 38.9912069,25.5 37.9912069,28.1",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(240, 238, 233)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 3,
    id: "STROKE_a0bdaa0b-72f0-473b-9f4d-b254e551bf69_1586890906461",
    d: "M20.1912069,155.8 C21.5912069,155.4 28.2912069,154.6 30.0912069,154.2",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(240, 238, 233)"
    }
  }), /*#__PURE__*/React.createElement("line", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 3,
    id: "STROKE_4c2f79e5-7b3f-4ccd-a6aa-264ff9d5e6a6_1586890906461",
    y2: 163.6,
    x2: 24.5912069,
    y1: 163.5,
    x1: 20.3912069,
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(240, 238, 233)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 3,
    id: "STROKE_0f9379fc-86bf-4600-b913-0e32842e4e1a_1586890906461",
    d: "M388.791207,552.9 C388.491207,553.1 387.791207,564.2 387.691207,564.8",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(240, 238, 233)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 3,
    id: "STROKE_3db7a005-6e02-4ec0-a7e2-e65707a4aa33_1586890906461",
    d: "M398.291207,555.7 C398.191207,558.2 397.991207,562 397.591207,564.2",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(240, 238, 233)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "#000000",
    strokeWidth: 0.2,
    id: "STROKE_3aeaa147-3552-4309-a633-d02ee2918270_1586890906461",
    d: "M423.591207,555 C427.491207,554.9 427.491207,561.1 423.591207,561 C419.691207,561.1 419.691207,555 423.591207,555 Z",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(240, 238, 233)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 3,
    id: "STROKE_131709a5-7398-4894-9dd5-d46fa574a232_1586890906461",
    d: "M425.891207,132.5 C427.791207,130.4 433.291207,129.5 436.091207,128.4",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(240, 238, 233)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 3,
    id: "STROKE_2d995f5e-8f0a-4d48-a348-a7a26cfe2a15_1586890906461",
    d: "M430.291207,110.5 C432.091207,109.6 437.891207,108.3 440.091207,107.5",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(240, 238, 233)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 3,
    id: "STROKE_b969443d-69b8-474b-87f3-e4c2ab2f9cf6_1586890906461",
    d: "M432.991207,95.7 C433.991207,94.3 434.791207,94.5 437.391207,93.3",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(240, 238, 233)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 3,
    id: "STROKE_425311f7-079d-4ec3-bbca-690844c34b81_1586890906461",
    d: "M433.691207,443.1 C433.091207,442.5 432.691207,442.6 431.891207,442.6",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(240, 238, 233)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 3,
    id: "STROKE_bbe56b82-8d3d-4449-b215-06c0ed1c7a58_1586890906461",
    d: "M435.791207,466.1 C437.191207,465 438.491207,463.9 439.691207,462.6",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(240, 238, 233)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "#000000",
    strokeWidth: 0.2,
    id: "STROKE_557c8738-c95b-4aaa-983b-24df8f1a7d0f_1586890906461",
    d: "M443.691207,422.2 C447.591207,422.1 447.591207,428.3 443.691207,428.2 C439.791207,428.3 439.791207,422.1 443.691207,422.2 Z",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(240, 238, 233)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "#000000",
    strokeWidth: 0.2,
    id: "STROKE_b68aacf4-331b-4eb3-9fba-01335c32d018_1586890906461",
    d: "M59.1912069,556.9 C63.0912069,556.8 63.0912069,563 59.1912069,562.9 C55.2912069,563 55.2912069,556.8 59.1912069,556.9 Z",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(240, 238, 233)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 3,
    id: "STROKE_0849fa46-e492-4275-a52f-963501b953cc_1586890906461",
    d: "M74.6912069,546.7 C74.4912069,545.8 74.8912069,545.1 75.4912069,543.8",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(240, 238, 233)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "#000000",
    strokeWidth: 0.2,
    id: "STROKE_99753bfa-4460-4750-a2d2-d1ec9b0876a9_1586890906461",
    d: "M96.9912069,547.7 C100.891207,547.6 100.891207,553.8 96.9912069,553.7 C93.0912069,553.8 93.0912069,547.7 96.9912069,547.7 Z",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(240, 238, 233)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "#000000",
    strokeWidth: 0.2,
    id: "STROKE_6bab7dc9-8888-43d2-bac0-79581cdc5be2_1586890906461",
    d: "M17.5912069,182.1 C21.4912069,182 21.4912069,188.2 17.5912069,188.1 C13.6912069,188.2 13.6912069,182.1 17.5912069,182.1 Z",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(240, 238, 233)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "#000000",
    strokeWidth: 0.2,
    id: "STROKE_b34c08ca-7440-4efe-9f51-27240ea7dd94_1586890906461",
    d: "M35.7912069,171.3 C39.6912069,171.2 39.6912069,177.4 35.7912069,177.3 C31.8912069,177.3 31.8912069,171.2 35.7912069,171.3 Z",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(240, 238, 233)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "#000000",
    strokeWidth: 0.2,
    id: "STROKE_ec7665ca-08a1-4f62-8602-5db375489199_1586890906461",
    d: "M10.9912069,32.6 C14.8912069,32.5 14.8912069,38.7 10.9912069,38.6 C7.09120691,38.6 7.09120691,32.5 10.9912069,32.6 Z",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(240, 238, 233)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "#000000",
    strokeWidth: 0.2,
    id: "STROKE_63147e3c-33c1-4e33-958d-077b54161d10_1586890906461",
    d: "M421.991207,11.3 C425.891207,11.2 425.891207,17.4 421.991207,17.3 C418.091207,17.4 418.091207,11.3 421.991207,11.3 Z",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(240, 238, 233)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "#000000",
    strokeWidth: 0.2,
    id: "STROKE_8921ec8d-ba21-49d8-86f2-6f87370058bf_1586890906461",
    d: "M430.791207,22.5 C434.691207,22.4 434.691207,28.6 430.791207,28.5 C426.991207,28.6 426.991207,22.4 430.791207,22.5 Z",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(240, 238, 233)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 3,
    id: "STROKE_661e2c0c-da9a-4d3e-8c6b-19300d012070_1586890906461",
    d: "M431.891207,26.5 C431.591207,26.2 431.191207,25.8 430.791207,25.4",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(240, 238, 233)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "#000000",
    strokeWidth: 0.2,
    id: "STROKE_e69f2c5e-d256-4a28-a071-277d1c54fb43_1586890906461",
    d: "M429.291207,40.8 C433.191207,40.7 433.191207,46.9 429.291207,46.8 C425.391207,46.9 425.391207,40.7 429.291207,40.8 Z",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(240, 238, 233)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "#000000",
    strokeWidth: 0.2,
    id: "STROKE_1bf13978-ea39-43ff-b43e-bb2d1db9147b_1586890906461",
    d: "M446.391207,550.5 C450.291207,550.4 450.291207,556.6 446.391207,556.5 C442.491207,556.6 442.491207,550.5 446.391207,550.5 Z",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(240, 238, 233)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "#000000",
    strokeWidth: 0.2,
    id: "STROKE_a0c99f13-cede-4e52-8ed5-9e4a9b1618fa_1586890906461",
    d: "M5.89120691,313.9 C9.79120691,313.8 9.79120691,320 5.89120691,319.9 C1.99120691,320 1.99120691,313.9 5.89120691,313.9 Z",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(240, 238, 233)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "#000000",
    strokeWidth: 0.2,
    id: "STROKE_b8de074c-66be-4281-a651-f0b89333762e_1586890906461",
    d: "M10.6912069,297.7 C14.5912069,297.6 14.5912069,303.8 10.6912069,303.7 C6.79120691,303.8 6.79120691,297.7 10.6912069,297.7 Z",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(240, 238, 233)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 3,
    id: "STROKE_77e80929-7789-45c5-b959-8fa96e1387c5_1586890906461",
    d: "M12.2912069,299.4 C11.6912069,299.5 11.1912069,299.9 10.6912069,300.7",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(240, 238, 233)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 3,
    id: "STROKE_2813956d-5be9-4906-9d22-66a214a841a3_1586890906461",
    d: "M13.5912069,281.7 C12.0912069,280 12.3912069,280.5 10.3912069,280",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(240, 238, 233)"
    }
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgParchment);
export default __webpack_public_path__ + "static/media/Parchment.130ac6cd3f4539d4c6f60412ff91dd45.svg";
export { ForwardRef as ReactComponent };